<template>
  <div>
    <v-data-table
      class="elevation-2"
      :headers="headers"
      :items="list"
      :loading="loading"
      sort-by="calories"
      :loading-text="$table_loading_text"
      :page.sync="page"
      :items-per-page="filter.item_per_page"
      hide-default-footer
      show-select
      item-key="_id"
      v-model="selected"
      @input="$emit('on-selected', selected)"
    >
      <template v-slot:[`item.date`]="{ item }">
        {{ item.date | moment($formatDate) }}
      </template>
      <template v-slot:[`item.car_type`]="{ item }">
        {{ carTypeRegistrationCode(item.car_type) }}
      </template>
      <template v-slot:[`item.is_original_document`]="{ item }">
        <div v-if="item.is_original_document">ตัวจริง</div>
        <div v-else>สำเนา</div>
      </template>
      <template v-slot:[`item.third_insurance_name`]="{ item }">
        {{ item.insurance_data.third_insurance_name }}
      </template>
      <template v-slot:[`item.insurance_name`]="{ item }">
        {{ item.insurance_data.insurance_name }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn color="grey" small outlined rounded @click="edit(item._id)"
          >ดู</v-btn
        >
      </template>
      <template v-slot:footer>
        <table-pagination-custom
          :page="filter.page"
          :itemsPerPage="filter.item_per_page"
          :length="pageCount"
          @change-page="onChangePage"
          @change-items-per-page="onChangeitemsPerPage"
        />
      </template>
    </v-data-table>

    <v-dialog persistent scrollable max-width="900" v-model="dialogForm">
      <InProgressForm
        :item="dialogFormData"
        :oldData="oldData"
        @onClose="dialogForm = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import { carTypeRegistrationCode } from '@/components/PrintDocument/carType';
import InProgressForm from './InProgressForm';

export default {
  components: {
    InProgressForm,
  },
  props: [
    'carTypeId',
    'search',
  ],
  data: () => ({
    dialogForm: false,
    dialogFormData: null,
    oldData: null,
    search: '',
    selected: [],
    loading: true,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    list: [],
    headers: [
      { text: 'วันที่', value: 'date', filterable: false },
      { text: 'ทะเบียน', value: 'car_plate', filterable: false },
      { text: 'จังหวัด', value: 'province', filterable: false },
      { text: 'ประเภท', value: 'car_type', filterable: false },
      { text: 'เอกสาร', value: 'is_original_document', filterable: false },
      { text: 'พรบ.', value: 'third_insurance_name', filterable: false },
      { text: 'ประกันภัย', value: 'insurance_name', filterable: false },
      // { text: 'ไม่สำเร็จ', value: 'reason_on_fail', filterable: false },
      { text: 'โน๊ต', value: 'note', filterable: false },
      { text: '', value: 'actions', filterable: false },
    ],
    isCar: true,
    filter: {
      branch_id: null,
      tracking_type: 1,
      tracking_status: 1,
      tax_renewal_round: '',
      car_type_filter: 0,
      item_per_page: 10,
      page: 1,
      start_with: '',
    },
  }),
  mounted() {
    this.filter.branch_id = this.$store.state.selected_branch._id;
    this.getData();
  },
  methods: {
    carTypeRegistrationCode,
    async getData() {
      this.loading = true;
      let body = {
        token: this.$jwt.sign(this.filter, this.$privateKey, {
          noTimestamp: true,
        }),
      };
      await this.$axios
        .post(`${this.$baseUrl}/process/get_process`, body)
        .then((res) => {
          this.list = res.result.data;
          this.pageCount = res.result.total_page || 1;
        })
        .catch((err) => {
          console.log('err', err);
          this.$alertServerError({ title: err.error_message });
        });
      this.loading = false;
    },
    onChangePage(page) {
      this.filter.page = page;
      this.getData();
    },
    onChangeitemsPerPage(number) {
      this.filter.item_per_page = number;
      this.onChangePage(1);
    },

    openDialog() {
      this.dialogForm = true;
    },
    closeDialog() {
      this.dialogForm = false;
      this.getData();
    },
    
    async edit(id) {
      let body = {
        token: this.$jwt.sign({ process_id: id }, this.$privateKey, {
          noTimestamp: true,
        }),
      };
      await this.$axios
        .post(`${this.$baseUrl}/process/get_by_id`, body)
        .then((res) => {
          this.dialogFormData = res.result;
          this.oldData = {
            third_insurance_number:
              res.result.insurance_data.third_insurance_number,
            third_insurance_protection_start_date:
              res.result.insurance_data.third_insurance_protection_start_date,
            third_insurance_protection_end_date:
              res.result.insurance_data.third_insurance_protection_end_date,
            insurance_number: res.result.insurance_data.insurance_number,
            insurance_protection_start_date:
              res.result.insurance_data.insurance_protection_start_date,
            insurance_protection_end_date:
              res.result.insurance_data.insurance_protection_end_date,
          };
          this.dialogForm = true;
        })
        .catch((err) => {
          console.log('err', err);
          this.$alertServerError({ title: err.error_message });
        });
    },

    cancel() {},
  },
  watch: {
    dialogForm: function (newVal, oldVal) {
      if (!newVal) {
        this.getData();
        this.dialogFormData = null;
        this.oldData = null;
      }
    },
    carTypeId(nv, ov) {
      if (nv != ov) {
        console.log(ov);
        this.filter.car_type_filter = nv;
        this.getData();
      }
    },
    search(nv, ov) {
      if (nv != ov) {
        this.filter.start_with = nv;
        this.getData();
      }
    },
  },
};
</script>
